var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1296,
    height: 145,
    viewBox: "0 0 1296 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1017.62 247.465C985.923 296.526 930.754 329 868 329C829.699 329 794.224 316.903 765.186 296.322C742.84 369.095 675.098 422 595 422C523.275 422 461.458 379.577 433.272 318.455C401.109 350.32 356.853 370 308 370C209.693 370 130 290.307 130 192C130 93.6933 209.693 14 308 14C379.725 14 441.542 56.4226 469.728 117.545C501.891 85.6803 546.147 66 595 66C633.301 66 668.776 78.0968 697.814 98.6782C720.16 25.9055 787.902 -27 868 -27C952.387 -27 1023.06 31.7232 1041.38 110.535C1073.08 61.4743 1128.25 29 1191 29C1289.31 29 1369 108.693 1369 207C1369 305.307 1289.31 385 1191 385C1106.61 385 1035.94 326.277 1017.62 247.465ZM-93 422C5.30667 422 85 342.307 85 244C85 145.693 5.30667 66 -93 66C-191.307 66 -271 145.693 -271 244C-271 342.307 -191.307 422 -93 422Z",
    fill: "#6C747A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.fa5def5360b8c1d7724543b98899bc58.svg";
export { ForwardRef as ReactComponent };